import { createSelector } from 'reselect';
import { AB_ROOT_KEY } from '@zocdoc-frontend-common/utils-ab';
import { createAbExperimentSelector } from '@zocdoc-frontend-common/utils-ab';
import {
    VARIANT_ON,
    FULL_STORY,
    FULL_STORY_BOOKING,
    PINA_REMEMBER_ME,
    ALLOW_GOVERNMENT_INSURANCE,
    PCE_STATIC_WITH_NEW_EXISTING_VALIDATION,
    VIRTUAL_VISITS,
    ENABLE_ZOCDOC_VIDEO_VISIT_LOCATIONS,
    PINA_BOOKING_COMPLETE_WARP_SPEED,
    BWA_SUPPRESS_SSO,
    PCE_SIGN_IN_FACEBOOK_SSO,
    PCE_SIGN_IN_APPLE_SSO,
    PCE_SIGN_IN_GOOGLE_SSO,
    PINA_BOOKING_COMPLETE_POBOLO,
    PINATA_EMAIL_FIRST_LOGIN_AND_SIGNUP,
    PCE_ENABLED_VACCINE_TRANSLATION,
    PINATA_MFA_AUTH,
    REMOVE_MEMBER_ID_OPTIONAL,
    REQUIRE_MEMBER_ID,
    REVIEW_AND_BOOK_INSURANCE_SCANNER,
    OUT_OF_STATE_VIDEO_VISIT,
} from './experiments';

export const getABParameters = (state) => state[AB_ROOT_KEY];

// Uncategorized selectors
export const shouldLoadFullStory = createSelector(
    getABParameters,
    (abParameters) =>
        abParameters[FULL_STORY.experimentId] === VARIANT_ON ||
        abParameters[FULL_STORY_BOOKING.experimentId] === VARIANT_ON
);

// Pina selectors

export const showRememberMeSelector =
    createAbExperimentSelector(PINA_REMEMBER_ME);

export const showStaticReviewAndBook = createAbExperimentSelector(
    PCE_STATIC_WITH_NEW_EXISTING_VALIDATION
);

export const allowGovernmentInsuranceSelector = createAbExperimentSelector(
    ALLOW_GOVERNMENT_INSURANCE
);

export const shouldShowVirtualVisitSelector = createSelector(
    getABParameters,
    (ab) => ab[VIRTUAL_VISITS.experimentId] === VARIANT_ON
);

export const shouldShowZocdocVideoVisit = createSelector(
    getABParameters,
    (ab) => ab[ENABLE_ZOCDOC_VIDEO_VISIT_LOCATIONS.experimentId] === VARIANT_ON
);

export const shouldShowCovidVaccineRebookingPrompt = createSelector(
    getABParameters,
    (ab) => ab[PINA_BOOKING_COMPLETE_WARP_SPEED.experimentId] === VARIANT_ON
);

export const shouldSuppressSsoLogin = createSelector(
    getABParameters,
    (ab) => ab[BWA_SUPPRESS_SSO.experimentId] === VARIANT_ON
);

export const useFacebookSsoOnSignInPage = createSelector(
    getABParameters,
    (ab) => ab[PCE_SIGN_IN_FACEBOOK_SSO.experimentId] === VARIANT_ON
);

export const useGoogleSsoOnSignInPage = createSelector(
    getABParameters,
    (ab) => ab[PCE_SIGN_IN_GOOGLE_SSO.experimentId] === VARIANT_ON
);

export const useAppleSsoOnSignInPage = createSelector(
    getABParameters,
    (ab) => ab[PCE_SIGN_IN_APPLE_SSO.experimentId] === VARIANT_ON
);

export const usePoboloBookingView = createAbExperimentSelector(
    PINA_BOOKING_COMPLETE_POBOLO
);

export const pinataEmailFirstSelector = createAbExperimentSelector(
    PINATA_EMAIL_FIRST_LOGIN_AND_SIGNUP
);

export const shouldShowTranslatorSelector = createAbExperimentSelector(
    PCE_ENABLED_VACCINE_TRANSLATION
);

export const shouldShowMFAInAuthSelector =
    createAbExperimentSelector(PINATA_MFA_AUTH);

export const shouldRemoveOptionalMemberIdCopySelector =
    createAbExperimentSelector(REMOVE_MEMBER_ID_OPTIONAL);

export const shouldRequireMemberIdSelector =
    createAbExperimentSelector(REQUIRE_MEMBER_ID);

export const shouldShowReviewAndBookScanner = createAbExperimentSelector(
    REVIEW_AND_BOOK_INSURANCE_SCANNER
);

export const shouldShowOutOfStateVideoVisitBanner = createAbExperimentSelector(
    OUT_OF_STATE_VIDEO_VISIT
);
